import { EntityAutocompletePicker, EntityTagFilter } from '@backstage/plugin-catalog-react';

import { EntityTagOrFilter } from './EntityTagOrFilter';

export type EntityTagOrPickerProps = {
  showCounts?: boolean;
  initialFilter?: string[];
  hidden?: boolean;
};

/**
 * Catalog tag picker wired to the OR-based tag filter.
 *
 * Selecting multiple tags shows templates that have ANY of the selected tags,
 * in contrast to the default EntityTagPicker which requires ALL tags (AND).
 */
export const EntityTagOrPicker = (props: EntityTagOrPickerProps) => {
  return (
    <EntityAutocompletePicker
      label="Tags"
      name="tags"
      path="metadata.tags"
      Filter={EntityTagOrFilter as unknown as typeof EntityTagFilter}
      showCounts={props.showCounts}
      initialSelectedOptions={props.initialFilter ?? []}
      hidden={props.hidden}
    />
  );
};
